import { ComponentLoader } from '@bythepixel/component-loader';
import DualRange from '@Front/modules/pages/facetedSearch/dualRange';
import Range from '@Front/modules/pages/facetedSearch/range';
import FacetedSearch from '@Front/modules/pages/facetedSearch/facetedSearch';
import VehicleComparisonController from '@Core/controllers/vehicleComparisonController';
import NotificationBanner from '@Core/components/notificationBanner';

window.facetedSearch = new ComponentLoader(document, [
  DualRange,
  FacetedSearch,
  NotificationBanner,
  Range,
  VehicleComparisonController,
]);
